import React, { createContext, ReactNode, useContext } from "react";
import * as Sentry from "@sentry/react";
import { IErrorMonitor } from "../../domain/monitoring/IErrorMonitor";
import { MonitoringFactory } from "../../infrastructure/monitoring/MonitoringFactory";

// Singleton — se inicializa una sola vez al cargar el módulo
const monitor: IErrorMonitor = MonitoringFactory.create();

export const MonitoringContext = createContext<IErrorMonitor>(monitor);

interface MonitoringProviderProps {
  children: ReactNode;
  fallback?: React.ReactElement;
}

export const MonitoringProvider: React.FC<MonitoringProviderProps> = ({
  children,
  fallback,
}) => {
  const isEnabled = process.env.REACT_APP_SENTRY_ENABLED === "true";

  const content = (
    <MonitoringContext.Provider value={monitor}>
      {children}
    </MonitoringContext.Provider>
  );

  if (isEnabled) {
    return (
      <Sentry.ErrorBoundary
        fallback={fallback ?? <p>Ocurrió un error inesperado.</p>}
      >
        {content}
      </Sentry.ErrorBoundary>
    );
  }

  return content;
};

export const useMonitoring = (): IErrorMonitor => useContext(MonitoringContext);
